import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { Box, MenuItem, Select, SelectChangeEvent, Stack, Typography } from '@mui/material'

import { IFeatures } from '../api'
import { categoryIconMap } from '../lib/category-icon-map'
import { formatFeatureValue } from '../lib/format-feature-value'

import styles from './subscription.module.scss'

interface FeaturesSectionProps {
	currentTokenLimitUID: string
	onCurrentTokenLimitUIDChange: (limit: string) => void
	features: IFeatures[] | null
	tokenLimits: Array<{ value: string; label: string }>
}

export const FeaturesSection = ({ currentTokenLimitUID, onCurrentTokenLimitUIDChange, features, tokenLimits }: FeaturesSectionProps) => {
	return (
		<Box width='100%' textAlign='start' marginTop={'50px'}>
			<Stack direction={'row'} justifyContent={'start'} alignItems={'center'} className={styles.selectContainer}>
				<Typography className={styles.title}>Возможности с подпиской</Typography>
				<Select
					value={currentTokenLimitUID}
					onChange={(e: SelectChangeEvent<string>) => onCurrentTokenLimitUIDChange(e.target.value)}
					IconComponent={KeyboardArrowDownIcon}
					MenuProps={{
						PaperProps: {
							className: styles.selectMenuPaper,
						},
						MenuListProps: {
							className: styles.selectMenuList,
						},
					}}
					className={styles.tokenSelect}
				>
					{tokenLimits.map((limit) => (
						<MenuItem key={limit.value} value={limit.value} className={styles.selectMenuItem}>
							{limit.label}
						</MenuItem>
					))}
				</Select>
			</Stack>
			<Box className={styles.blocksMapper}>
				{features?.map((featureGroup, idx) => (
					<Box key={idx} className={styles.featureBlock}>
						<Stack direction='row' alignItems='center' spacing={2} className={styles.featureHeader}>
							{categoryIconMap[featureGroup.name] && (
								<Box className={styles.featureIcon}>{categoryIconMap[featureGroup.name]}</Box>
							)}
							<Typography className={styles.featureTitle}>{featureGroup.name}</Typography>
						</Stack>
						<Box component='hr' className={styles.featureDivider} />
						<Stack spacing={2}>
							{featureGroup.features.map((feature, featureIdx) => {
								let { number, unit, more } = formatFeatureValue(feature.quantity, feature.measurement_unit)

								return (
									<Box key={featureIdx} className={styles.featureItem}>
										<Typography className={styles.featureText}>{feature.name}</Typography>
										<Box sx={{ display: 'flex', alignItems: 'baseline' }}>
											<Typography className={styles.featureText}>
												{number == '-' ? (
													<Box sx={{ border: '1px solid white', width: '30px' }}></Box>
												) : (
													<>
														{' '}
														<span className={styles.featureUnit}>{more}</span> {number}
														<span className={styles.featureUnit}> {unit}</span>
													</>
												)}
											</Typography>
										</Box>
									</Box>
								)
							})}
						</Stack>
					</Box>
				))}
			</Box>
			<Typography className={styles.infoText}>
				<Box className={styles.infoIcon} />
				Для каждой отдельной модели указано примерное количество генераций, как если бы вы пользовались{' '}
				<span className={styles.infoUnderText}>только</span> ей. <br />
				Количество генераций может варьироваться в зависимости от используемых параметров каждой конкретной модели.
			</Typography>
		</Box>
	)
}
